import { authRoles } from "../auth/auth";

export const fuseNavigationConfig = [
    {
        'id': 'applications',
        'title': 'Applications',
        'type': 'group',
        'icon': 'apps',
        'children': [
            {
                'id': 'datagroups-component',
                'title': 'Data Groups',
                'type': 'item',
                'icon': 'dashboard',
                'url': '/data-groups'
            },
            /*{
                'id'   : 'define-data-group-component',
                'title': 'Define Data Group',
                'type' : 'item',
                'icon' : 'dashboard',
                'url'  : '/dgdefine'
            },
            {
                'id'   : 'query-component',
                'title': 'Query',
                'type' : 'item',
                'icon' : 'dashboard',
                'url'  : '/query'
            }*/
        ]
    },
    {
        'id': 'administration',
        'title': 'Administration',
        'type': 'group',
        'icon': 'business',
        'auth': authRoles.admin,
        'children': [
            {
                'id': 'user-management',
                'title': 'User Management',
                'type': 'item',
                'icon': 'people',
                'url': '/users'
            },
            {
                'id': 'settings-screen',
                'title': 'Settings',
                'type': 'item',
                'icon': 'settings',
                'url': '/settings'
            }
        ]
    }
];


// WEBPACK FOOTER //
// ./src/fuse-configs/fuseNavigationConfig.js